import { Skeleton } from '@mui/material'

export default function BodySkeleton() {
  return (
    <Skeleton variant="rectangular" sx={styles.cardMax} animation="pulse" />
  )
}

const styles={
    
    cardMax: {
        flex: 1, 
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        borderRadius: "4px", 
        minHeight: "420px", 
        backgroundColor: "primary.main"
    },

}